// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".last-run-header--lastRunHeader--3sXFtDGW {\n  align-items: flex-end;\n  background: #e2f4f8;\n  display: flex;\n  flex-direction: column;\n  font-weight: bold;\n  height: auto;\n  white-space: nowrap;\n  width: 82px;\n}\n.last-run-header--lastRunHeader--3sXFtDGW .last-run-header--lastRunHeaderText--34r0D3Ex {\n  align-self: flex-end;\n  margin: auto auto 10px;\n  padding: 0 10px;\n  text-align: center;\n}\n.last-run-header--lastRunHeader--3sXFtDGW .last-run-header--visualExtension--3SMfs9i9 {\n  background: #f5fbfc;\n  height: 30px;\n  margin-top: 149px;\n  width: 100%;\n}\n", ""]);
// Exports
exports.locals = {
	"lastRunHeader": "last-run-header--lastRunHeader--3sXFtDGW",
	"lastRunHeaderText": "last-run-header--lastRunHeaderText--34r0D3Ex",
	"visualExtension": "last-run-header--visualExtension--3SMfs9i9"
};
module.exports = exports;
